export default __webpack_public_path__ + "static/media/14.4fcc0865.mp3";